import { is } from 'immutable';
import { createSelectorCreator, defaultMemoize } from 'reselect';

const createSelector = createSelectorCreator(defaultMemoize, is);

export default createSelector;
